import { Link } from "react-router-dom";
import { Users, Trophy, UserCircle, ArrowRight } from "@phosphor-icons/react";
import { useFetch } from "../lib/useFetch";

export const Hold = () => {
  const { data: teams, loading } = useFetch("/teams");

  return (
    <section
      id="hold"
      data-testid="hold-section"
      className="border-t border-neutral-900 bg-neutral-950 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex flex-col gap-4">
          <span className="section-eyebrow">04 · Roster</span>
          <h2 className="font-heading text-5xl uppercase leading-none tracking-tight text-white sm:text-6xl lg:text-7xl">
            Hold & Trænere
          </h2>
          <p className="mt-2 max-w-2xl font-body text-neutral-400">
            Klik på et hold for at se trup, kampprogram og opdateringer.
          </p>
        </div>

        {loading && (
          <p className="mt-10 mono-label text-neutral-500">Loader hold…</p>
        )}

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {teams.map((t, i) => (
            <Link
              key={t.id}
              to={`/hold/${t.id}`}
              data-testid={`team-card-${t.id}`}
              className="group relative block border border-neutral-800 bg-black p-6 transition-all duration-200 hover:-translate-y-1 hover:border-brand"
            >
              <div className="flex items-start justify-between">
                <span className="mono-label text-neutral-500">
                  #{String(i + 1).padStart(2, "0")}
                </span>
                <span className="mono-label text-brand">{t.league}</span>
              </div>

              <h3 className="mt-6 font-heading text-3xl uppercase leading-none tracking-tight text-white">
                {t.name}
              </h3>

              <div className="mt-8 space-y-3 border-t border-neutral-900 pt-5">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-neutral-400">
                    <Trophy size={16} className="text-brand" />
                    <span className="mono-label">Cheftræner</span>
                  </div>
                  <span className="font-body text-sm text-white">{t.coach}</span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-neutral-400">
                    <UserCircle size={16} />
                    <span className="mono-label">Assistent</span>
                  </div>
                  <span className="font-body text-sm text-neutral-300">
                    {t.assistant || "—"}
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-neutral-400">
                    <Users size={16} />
                    <span className="mono-label">Trup</span>
                  </div>
                  <span className="font-mono text-sm text-white">
                    {t.squad_size || 0} spillere
                  </span>
                </div>
              </div>

              <div className="mono-label mt-6 inline-flex items-center gap-1 text-neutral-500 transition-colors group-hover:text-brand">
                Se holdet <ArrowRight size={12} />
              </div>

              <div
                className="absolute inset-x-0 bottom-0 h-[3px] origin-left scale-x-0 bg-brand transition-transform duration-300 group-hover:scale-x-100"
                aria-hidden="true"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
